import React from 'react'
import PropTypes from 'prop-types'
import { Loader } from 'components/atoms'
import { VideoPlayer } from 'components/organisms'
import { Search } from 'components/templates'
import RenderRelatedContent from './Components/RelatedContent'
import defaultBg from 'assets/images/default-bg.jpg'
import * as S from './styled'

const Single = ({
  zone,
  searchMode,
  search,
  searchQuery,
  handleStatus,
  isVideo,
  isEvent,
  time,
  date,
  content,
  relatedContent,
  contentType,
  contentId,
  isContentLoading,
  isRelatedLoading,
}) => {
  const backUpImage = () => {
    return content.ilustrationMime && content.ilustrationMime.includes('image') ? content.ilustrationUrl : defaultBg
  }
  return (
    <>
      {searchMode ? (
        <Search search={search} searchQuery={searchQuery} zone={zone} handleStatus={handleStatus} />
      ) : content && !isContentLoading && !isRelatedLoading ? (
        <S.ContentContainer>
          <S.ImageContainer image={!isContentLoading ? backUpImage() : ''}>
            {isVideo ? (
              <S.VideoBg>
                <VideoPlayer video={content.videoUrl} contentType={contentType} contentId={contentId} />
              </S.VideoBg>
            ) : (
              <S.DetailsContainer>
                <S.Info>
                  <S.Title>{content.name}</S.Title>
                  <S.Description isEvent={isEvent}>{isEvent ? `${date} - ${time}` : content.description}</S.Description>
                  {isEvent && <S.Description>{content.description}</S.Description>}
                </S.Info>
              </S.DetailsContainer>
            )}
          </S.ImageContainer>
          {relatedContent?.length > 1 && !isRelatedLoading && (
            <RenderRelatedContent content={content} contentType={contentType} items={relatedContent} />
          )}
        </S.ContentContainer>
      ) : (
        <Loader />
      )}
    </>
  )
}

Single.defaultProps = {
  search: {} || [],
  searchMode: false,
  handleStatus: () => {},
  time: '',
  date: '',
  searchQuery: '',
}

Single.propTypes = {
  zone: PropTypes.string.isRequired,
  search: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  searchMode: PropTypes.bool,
  handleStatus: PropTypes.func,
  isVideo: PropTypes.bool.isRequired,
  isEvent: PropTypes.bool.isRequired,
  time: PropTypes.string,
  date: PropTypes.string,
  content: PropTypes.object.isRequired,
  relatedContent: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  contentType: PropTypes.string.isRequired,
  contentId: PropTypes.string.isRequired,
  isContentLoading: PropTypes.bool.isRequired,
  isRelatedLoading: PropTypes.bool.isRequired,
  searchQuery: PropTypes.string,
}

export default Single
